import { LinkRoute } from '@/components/common/Link'
import { SectionLabel } from '@/components/common/SectionLabel'
import { type WPPostType } from '@/defs/wordpress'
import { buildRoute } from '@/utils/routeUtil'

import styles from './ArticleCategory.module.scss'

type Props = {
  category: WPPostType['category']
}

export const ArticleCategory = ({ category }: Props) =>
  category && (
    <div className={styles.container}>
      <LinkRoute href={buildRoute({ articleCategorySlug: category.slug, section: 'articlesCategory' })}>
        <SectionLabel label={category.label} />
      </LinkRoute>
    </div>
  )
